import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {CentreService} from "../../../../services/centre.service";
import {EducationService} from "../../education.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ChildService} from "../../../../components/child/child.service";
import {DatePipe, TitleCasePipe} from "@angular/common";
import {MatDialog} from "@angular/material/dialog";
import {MatSelectChange} from "@angular/material/select";
import {
  ViewEducationIndividualComponent
} from "../../components/view-education-individual/view-education-individual.component";
import firebase from "firebase/compat";
import Timestamp = firebase.firestore.Timestamp;
import {ViewEducationGroupComponent} from "../../components/view-education-group/view-education-group.component";

@Component({
  selector: 'app-education-group-reporting',
  templateUrl: './education-group-reporting.component.html',
  styleUrls: ['./education-group-reporting.component.scss']
})
export class EducationGroupReportingComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  sessionType = ''
  centres$: Observable<Centre[]>
  selectedCentre: any
  conductedBy = ''
  userData = JSON.parse(localStorage.getItem('userData')!)
  startDate?: Date | null
  endDate?: Date | null
  educationData: any[] = []
  dataSource!: MatTableDataSource<any>;
  mAllData: any[] = []
  mFilteredData: any[] = []
  displayedColumns: string[] = ['childName', 'centre', 'date', 'timing', 'type_session', 'subject', 'topic_covered', 'remark', 'teacher', 'createdAt', 'action'];


  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;


  constructor(readonly centreService: CentreService,
              readonly eduationService: EducationService,
              readonly matSnackBar: MatSnackBar,
              readonly childService: ChildService,
              private titlecasePipe: TitleCasePipe,
              private readonly matDialog: MatDialog,
              private datePipe: DatePipe,
              private educationService: EducationService,
  ) {

    this.centres$ = centreService.getAllCentres()
    this.mFilteredData=[]
    this.dataSource = new MatTableDataSource(this.mFilteredData);

  }

  ngOnInit(): void {
    this.educationService.getGroupEducationSessions2().pipe(takeUntil(this._destroyed$)).subscribe(re => {
      this.mAllData = re
      // console.log(this.educationData)
      // this.mAllData = this.educationData
      this.mFilteredData = this.mAllData
      this.dataSource = new MatTableDataSource(this.mFilteredData);
      this.dataSource.sort = this.sort!
      this.dataSource.paginator = this.paginator


      // console.log(this.selectedCentre)
    })

  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  fetchByCenter($event: MatSelectChange) {
    console.log('FETCH CENTER SELECTED IN EDUCATION')
    let c = $event.value
    this.selectedCentre = {
      centreName: c.centreName,
      centreCode: c.centreCode
    }

  }

  getCentresString(centres: any) {
    let arr: any[] = []
    centres.forEach((it: { centreName: any; }) => {
      arr.push(it.centreName)
    })
    return arr
  }

  getChildrenString(children: any) {
    let arr: any[] = []
    children.forEach((it: { childName: any; }) => {
      arr.push(' ' + it.childName)
    })
    return arr
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

  }

  Search() {
    this.mFilteredData = this.mAllData
    console.log('BeforFilter', this.mFilteredData)
    // if centre selected
// 100
    if (this.selectedCentre != null) {
      console.log('Sleected Centre', this.selectedCentre)
      console.log('into selectedCentre')
      this.mFilteredData = this.mFilteredData.filter((x) => x.centreCode == this.selectedCentre)
    }
    if (this.startDate != null) {
      console.log('into startDate')

      this.mFilteredData = this.mFilteredData.filter((x) => x.dateOfAssessment.toDate() <= this.startDate!)
// 50
    }
    if (this.endDate != null) {
      console.log('into end Date')

      // 50
      this.mFilteredData = this.mFilteredData.filter((x) => x.dateOfAssessment.toDate() >= this.endDate!)

    }

    if (this.sessionType != null && this.sessionType != '') {
      console.log('into sesstionType')
      this.mFilteredData = this.mFilteredData.filter((x) => x.sessionType == this.sessionType)
    }

    if (this.conductedBy != null && this.conductedBy != '') {
      this.mFilteredData = this.mFilteredData.filter((x) => x.personConductingTest == this.conductedBy)
      console.log(this.mFilteredData)
    }

    console.log('filtered Data',this.mFilteredData.length)
    this.dataSource.data = this.mFilteredData
  }

  clearAll() {
    this.startDate = null
    this.endDate = null
    this.conductedBy = ''
    this.selectedCentre = null
    this.sessionType = ''
  }


  viewDialog(element: any) {
    this.matDialog.open(ViewEducationGroupComponent, {
      data: element,
      width: '800%',
      height: '90%'
    })

  }

  getDateandTime(date: Date): any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d, 'dd-MMM-yyyy h:mm a ');
    return datePipeString
  }

  getDate(date: Date): any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d, 'dd-MMM-yyyy');
    return datePipeString
  }

  getTime(date: Date): any {
    let datePipeString: string | null = "NA"

    if (date != null) {
      let d = (date as unknown as Timestamp).toDate()
      datePipeString = this.datePipe.transform(d, "h:mm a")
      // console.log('DATEPIPE STRING',datePipeString )

      return datePipeString
    }
  }

}
